import React from 'react'
import { Card } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
var moment = require('moment');
class InitiativeCard extends React.Component {
    async goToInitiative(id, data) {
        await dispatch.home.redirectFromEventStream(true);
        let pLoad = {
            id: id,
            data: data
        }
        await dispatch.initiatives.checkInitiatuiveAvailability(pLoad);
    }

    render() {

        let currentDate = moment().format('YYYY-MM-DD');
        var initiativeEndDate = moment(this.props.selectedInitiative.endDate, "YYYY-MM-DD");
        let isInitiativeEndDelayed = moment.duration(initiativeEndDate.diff(currentDate)).asDays();

        return (
            <div className="imageBlock cursor-pointer" onClick={() => this.goToInitiative(this.props.selectedInitiative._id, this.props.selectedInitiative)}>
                <Card className="appDefaultCard ">
                    <Card.Header>
                        <EllipsisTooltip
                            name={this.props.selectedInitiative.name}
                        />
                    </Card.Header>
                    <Card.Content >
                        <img className="fitImage" alt='' src={this.props.selectedInitiative.picture} />
                        {this.props.selectedInitiative.status === 1 && this.props.selectedInitiative.totalIssueCount > 0 ?
                            <div className="badge badgeIssue">Issue </div> :
                            this.props.selectedInitiative.status === 1 && (isInitiativeEndDelayed) < 0 ?
                                <div className="badge badgeCaution">Delayed </div> :
                                this.props.selectedInitiative.status === 1 && this.props.selectedInitiative.totalActivityCount !== this.props.selectedInitiative.totalCompletedCount
                                    && (this.props.selectedInitiative.totalInProgressCount > 0 || this.props.selectedInitiative.totalCompletedCount > 0) ?
                                    <div className="badge badgeOnTrack">In Progress </div> :
                                    this.props.selectedInitiative.status === 1 && this.props.selectedInitiative.totalInProgressCount === 0 ?
                                        <div className="badge badgeNotStarted">Not Started </div> : ""

                        }
                        {this.props.selectedInitiative.status === -1 && <div className="badge badgeDraft">Draft </div>}
                        {this.props.selectedInitiative.status === 0 && <div className="badge badgeIndesign">In Design </div>}
                        {this.props.selectedInitiative.status === 2 && <div className="badge badgeCompleted">Completed </div>}
                        {this.props.selectedInitiative.status === 3 && <div className="badge badgeClosed">Closed </div>}
                        {this.props.selectedInitiative.status === 4 && <div className="badge badgeInEdit">Editing </div>}
                        {this.props.selectedInitiative.status === 5 && <div className="badge badgeCanceled">Cancelled </div>}
                    </Card.Content>
                </Card>
            </div>
        )
    }
}

export default InitiativeCard;

